/* NORTHGATE sound: background track plus gritty synth sound effects and a vinyl-crackle bed.
   On by default: it tries to start the moment the page opens; browsers that block that start it on the first
   tap, click or key press. The switch under Bag mutes it, and the site remembers. */
(function () {
  if (window.__ngSound) return;
  window.__ngSound = 1;
  var D = document, cfg = window.NG_SOUND || {}, KEY = 'ng-sound';
  var AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return;

  var css = D.createElement('style');
  css.textContent = [
    '#ng-sound{position:fixed;right:max(16px,env(safe-area-inset-right,0px));top:calc(46px + env(safe-area-inset-top,0px));z-index:31;display:inline-flex;align-items:center;gap:7px;font-family:"DM Mono",monospace;font-weight:300;font-size:11px;letter-spacing:.06em;text-transform:none;color:#7d7c77;background:none;border:0;padding:4px 0;cursor:pointer}',
    '#ng-sound:hover,#ng-sound[aria-pressed="true"]{color:#121212}',
    '#ng-sound .bars{display:inline-flex;gap:2px;height:9px;align-items:flex-end}',
    '#ng-sound .bars i{width:2px;height:3px;background:currentColor}',
    '#ng-sound.live .bars i{animation:ng-eq .8s steps(4) infinite}',
    '#ng-sound .bars i:nth-child(2){animation-delay:-.27s}#ng-sound .bars i:nth-child(3){animation-delay:-.53s}',
    '@keyframes ng-eq{0%{height:3px}25%{height:9px}50%{height:5px}75%{height:8px}}',
    '@media (prefers-reduced-motion:reduce){#ng-sound .bars i{animation:none!important}}'
  ].join('\n');
  D.head.appendChild(css);

  var btn = D.createElement('button');
  btn.id = 'ng-sound'; btn.type = 'button';
  btn.innerHTML = '<span class="bars" aria-hidden="true"><i></i><i></i><i></i></span><span class="lbl">sound off</span>';
  btn.setAttribute('aria-pressed', 'false');
  D.body.appendChild(btn);
  var lbl = btn.querySelector('.lbl');

  var ctx = null, master = null, bus = null, noise = null, bed = null, music = null, on = false;

  function curve(k) {
    var n = 1024, c = new Float32Array(n);
    for (var i = 0; i < n; i++) { var x = i * 2 / n - 1; c[i] = (1 + k) * x / (1 + k * Math.abs(x)); }
    return c;
  }
  function build() {
    ctx = new AC();
    master = ctx.createGain(); master.gain.value = 0.9;
    var drive = ctx.createWaveShaper(); drive.curve = curve(3); drive.oversample = '2x';
    var tone = ctx.createBiquadFilter(); tone.type = 'lowpass'; tone.frequency.value = 7800;
    master.connect(drive); drive.connect(tone); tone.connect(ctx.destination);
    bus = ctx.createGain(); bus.gain.value = 0.75; bus.connect(master);
    noise = ctx.createBuffer(1, ctx.sampleRate, ctx.sampleRate);
    var d = noise.getChannelData(0);
    for (var i = 0; i < d.length; i++) d[i] = Math.random() * 2 - 1;
    /* vinyl bed: low hiss + sparse crackle, looped */
    var len = ctx.sampleRate * 3, vb = ctx.createBuffer(1, len, ctx.sampleRate), v = vb.getChannelData(0);
    for (var j = 0; j < len; j++) {
      v[j] = (Math.random() * 2 - 1) * 0.02;
      if (Math.random() < 0.00035) { var amp = 0.3 + Math.random() * 0.5; for (var k = 0; k < 24 && j + k < len; k++) v[j + k] += (Math.random() * 2 - 1) * amp * (1 - k / 24); }
    }
    bed = ctx.createBufferSource(); bed.buffer = vb; bed.loop = true;
    var bedHp = ctx.createBiquadFilter(); bedHp.type = 'highpass'; bedHp.frequency.value = 900;
    var bedG = ctx.createGain(); bedG.gain.value = 0.09;
    bed.connect(bedHp); bedHp.connect(bedG); bedG.connect(master);
    bed.start();
  }
  var live = false;
  function startMusic() {
    if (!cfg.music) return;
    if (!music) { music = new Audio(cfg.music); music.loop = true; music.preload = 'auto'; music.volume = 0.5; }
    var p = music.play();
    if (p && p.then) p.then(function () { mark(true); }, function () {}); else mark(true);
  }
  function mark(v) { live = v; btn.classList.toggle('live', v && on); }
  /* try to get going; returns quietly if the browser wants a tap first */
  function start() {
    if (!on) return;
    if (!ctx) build();
    if (ctx.state === 'suspended') { var r = ctx.resume(); if (r && r.then) r.then(function () { if (ctx.state === 'running') mark(true); }, function () {}); }
    else mark(true);
    startMusic();
  }
  function setOn(v, remember) {
    on = v;
    btn.setAttribute('aria-pressed', String(v));
    btn.setAttribute('aria-label', v ? 'Mute sound' : 'Turn sound on');
    lbl.textContent = v ? 'sound on' : 'sound off';
    if (v) { start(); play({ t: 'tick', v: 1 }); }
    else {
      if (ctx) ctx.suspend();
      if (music) music.pause();
      mark(false);
    }
    if (remember) { try { localStorage.setItem(KEY, v ? '1' : '0'); } catch (_) {} }
  }
  btn.addEventListener('click', function () { setOn(!on, true); });
  /* on unless this visitor muted it before */
  var muted = false;
  try { muted = localStorage.getItem(KEY) === '0'; } catch (_) {}
  if (!muted) {
    on = true;
    btn.setAttribute('aria-pressed', 'true');
    btn.setAttribute('aria-label', 'Mute sound');
    lbl.textContent = 'sound on';
    try { start(); } catch (_) {}
    var kick = function (e) {
      if (e.target && e.target.closest && e.target.closest('#ng-sound')) return;
      ['pointerdown', 'keydown', 'touchend'].forEach(function (ev) { D.removeEventListener(ev, kick, true); });
      if (on) start();
    };
    ['pointerdown', 'keydown', 'touchend'].forEach(function (ev) { D.addEventListener(ev, kick, true); });
  } else {
    btn.setAttribute('aria-label', 'Turn sound on');
  }

  /* ---------- synth helpers ---------- */
  function now() { return ctx.currentTime; }
  function env(g, t, a, d, peak) {
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(Math.max(peak, 0.0002), t + a);
    g.gain.exponentialRampToValueAtTime(0.0001, t + a + d);
  }
  function noiseSrc() { var s = ctx.createBufferSource(); s.buffer = noise; s.loop = true; return s; }
  function out(node, t, dur) { node.connect(bus); return node; }
  function osc(type, f0, f1, t, dur, peak, a) {
    var o = ctx.createOscillator(), g = ctx.createGain();
    o.type = type; o.frequency.setValueAtTime(f0, t);
    if (f1) o.frequency.exponentialRampToValueAtTime(f1, t + dur);
    env(g, t, a || 0.004, dur, peak);
    o.connect(g); out(g); o.start(t); o.stop(t + (a || 0.004) + dur + 0.05);
    return o;
  }
  function burst(type, f0, f1, q, t, dur, peak, a) {
    var s = noiseSrc(), f = ctx.createBiquadFilter(), g = ctx.createGain();
    f.type = type; f.Q.value = q || 1;
    f.frequency.setValueAtTime(f0, t);
    if (f1) f.frequency.exponentialRampToValueAtTime(f1, t + dur);
    env(g, t, a || 0.004, dur, peak);
    s.connect(f); f.connect(g); out(g);
    s.start(t, Math.random()); s.stop(t + (a || 0.004) + dur + 0.05);
  }
  var lastAt = {};
  function play(e) {
    if (!on || !ctx) return;
    var t = now(), v = e.v == null ? 1 : e.v, k = e.t;
    if (lastAt[k] && t - lastAt[k] < 0.04) return;
    lastAt[k] = t;
    switch (k) {
      case 'tick':
        burst('bandpass', 3200, 0, 3, t, 0.025, 0.18 * v);
        osc('square', 1700, 900, t, 0.02, 0.025 * v);
        break;
      case 'whoosh':
        burst('bandpass', 350, 2600, 1.4, t, 0.32, 0.42 * v, 0.06);
        break;
      case 'swish':
        burst('bandpass', 900, 3000, 2, t, 0.18, 0.12 * v, 0.03);
        break;
      case 'thud':
        osc('sine', 110, 38, t, 0.22, 0.7 * v);
        burst('lowpass', 900, 200, 0.7, t, 0.08, 0.35 * v);
        break;
      case 'dub': {
        var o = ctx.createOscillator(), g = ctx.createGain(), dl = ctx.createDelay(1), fb = ctx.createGain(), lp = ctx.createBiquadFilter();
        o.type = 'sine'; o.frequency.setValueAtTime(96, t); o.frequency.exponentialRampToValueAtTime(58, t + 0.3);
        env(g, t, 0.006, 0.34, 0.45 * v);
        dl.delayTime.value = 0.27; fb.gain.value = 0.38; lp.type = 'lowpass'; lp.frequency.value = 1100;
        o.connect(g); g.connect(bus); g.connect(dl); dl.connect(lp); lp.connect(fb); fb.connect(dl); lp.connect(bus);
        o.start(t); o.stop(t + 0.45);
        setTimeout(function () { try { fb.disconnect(); lp.disconnect(); } catch (_) {} }, 2200);
        burst('highpass', 2400, 0, 0.7, t, 0.03, 0.12 * v);
        break;
      }
      case 'zap':
        osc('sawtooth', 2400, 160, t, 0.38, 0.13);
        osc('square', 1800, 120, t + 0.01, 0.3, 0.05);
        [0.06, 0.14, 0.22].forEach(function (d) { osc('triangle', 2600 + Math.random() * 900, 0, t + d, 0.05, 0.05); });
        break;
      case 'thunder':
        burst('highpass', 2600, 0, 0.5, t, 0.07, 0.6);
        burst('lowpass', 1100, 120, 0.6, t + 0.02, 1.5, 0.75, 0.02);
        osc('sine', 70, 32, t, 0.8, 0.5);
        break;
      case 'shimmer':
        [880, 1047, 1319, 1568, 1760].forEach(function (f, i) { osc('sine', f, 0, t + i * 0.045, 0.5, 0.06); });
        break;
      case 'rattle':
        for (var i = 0; i < 6; i++) burst('bandpass', 2200 + Math.random() * 1600, 0, 4, t + i * 0.055, 0.03, 0.22 * v);
        break;
      case 'shutter':
        burst('highpass', 3800, 0, 0.8, t, 0.012, 0.55 * v);
        burst('bandpass', 1600, 700, 2, t + 0.045, 0.05, 0.4 * v);
        osc('sine', 120, 50, t + 0.04, 0.09, 0.35 * v);
        burst('highpass', 6000, 0, 0.5, t + 0.06, 0.4, 0.06 * v, 0.05);
        break;
      case 'pop':
        osc('sine', 600, 1700, t, 0.07, 0.25 * v);
        burst('highpass', 4000, 0, 0.7, t, 0.02, 0.3 * v);
        [2093, 2637, 3136].forEach(function (f, i) { osc('sine', f, 0, t + 0.04 + i * 0.03, 0.25, 0.04); });
        break;
      case 'night':
        osc('sine', 110, 0, t, 1.5, 0.12, 0.3); osc('sine', 164.8, 0, t + 0.05, 1.4, 0.08, 0.3);
        [1319, 1760, 2093].forEach(function (f, i) { osc('sine', f, 0, t + 0.3 + i * 0.18, 0.8, 0.02, 0.05); });
        break;
      case 'laugh':
        for (var j = 0; j < 7; j++) {
          burst('bandpass', 1500 - j * 110, 0, 5, t + j * 0.07, 0.04, 0.3);
          osc('square', 240 - j * 12, 170 - j * 10, t + j * 0.07, 0.04, 0.04);
        }
        break;
      case 'choir':
        [523.3, 659.3, 784, 1046.5].forEach(function (f, i) { osc('sine', f, 0, t + i * 0.03, 1.3, 0.05, 0.25); osc('triangle', f * 1.005, 0, t + i * 0.03, 1.2, 0.015, 0.3); });
        burst('highpass', 5000, 0, 0.4, t, 1.1, 0.03, 0.3);
        break;
      case 'buzz':
        osc('sawtooth', 120, 0, t, 0.85, 0.09, 0.01); osc('square', 60, 0, t, 0.85, 0.04, 0.01);
        for (var q = 0; q < 7; q++) burst('highpass', 3000 + Math.random() * 3000, 0, 0.7, t + Math.random() * 0.8, 0.015, 0.35);
        break;
      case 'tape':
        osc('sawtooth', 300, 2400, t, 0.45, 0.05); osc('square', 220, 1900, t + 0.02, 0.42, 0.025);
        burst('bandpass', 1800, 900, 3, t + 0.45, 0.05, 0.25);
        break;
      case 'rip':
        burst('bandpass', 3200, 500, 1.5, t, 0.28, 0.55 * v, 0.008);
        burst('highpass', 5000, 0, 0.6, t, 0.1, 0.25 * v);
        break;
      case 'blip':
        osc('square', 900 + Math.random() * 900, 0, t, 0.02, 0.03 * v);
        break;
      case 'heart':
        osc('sine', 70, 42, t, 0.16, 0.65); osc('sine', 66, 40, t + 0.22, 0.2, 0.55);
        break;
    }
  }
  window.addEventListener('ng:sfx', function (e) { play(e.detail || {}); });
  D.addEventListener('visibilitychange', function () {
    if (!on || !ctx) return;
    if (D.hidden) { ctx.suspend(); if (music) music.pause(); } else { ctx.resume(); startMusic(); }
  });
})();
